import { Box, Tabs, Button, Tab } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CARD_MIN_WIDTH = 429
export const CARD_MIN_WIDTH_SMALL = 345

export const IntegrationsTabsWrapper = styled(Box)<{ custom?: boolean }>`
  display: flex;
  justify-content: flex-start;
  margin: ${({ custom }) => (custom ? `${theme.spacing.large}px 0 0` : `${theme.spacing.small}px 0 0`)};
`

export const TabPanelWrapper = styled(Box)`
  background: ${theme.colors.pageBackground};
  height: 100%;
  min-height: calc(100vh - 211px); // subtract header height

  .card {
    background: transparent;
    padding: ${theme.spacing.small}px ${theme.spacing.small}px ${theme.spacing.small}px 0;
    margin-top: ${theme.spacing.medium}px;
    margin-bottom: ${theme.spacing.medium}px;
    border-bottom: 1px solid rgba(147, 143, 153, 0.12);
    margin-left: ${theme.spacing.medium}px;
    max-width: calc(100% - 465px);

    .data-source-wrapper {
      display: flex;
      align-items: center;
      margin-top: 22px;
      margin-bottom: ${theme.spacing.md}px;
      margin-left: ${theme.spacing.small}px;
    }

    .card-description {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.large};
      line-height: 20px;
      letter-spacing: 0.25px;
      color: ${theme.colors.foreground};
      padding-left: ${theme.spacing.small}px;
    }

    .source-card-wrapper {
      display: flex;
      align-items: center;
      margin-top: ${theme.spacing.md}px;
      margin-left: ${theme.spacing.small}px;
    }

    .title {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.xxLarge};
      line-height: 28px;
      color: ${theme.colors.menuItemText};
      margin-bottom: ${theme.spacing.half}px;
    }

    .description {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      color: ${theme.colors.menuItemText};
      letter-spacing: 0.25px;
      font-size: ${theme.typography.fontSize.large};
      line-height: 20px;
    }

    img:not(:last-of-type) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      margin-top: ${theme.spacing.lg}px;
    }
  }

  .cpi-short-description {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: ${theme.typography.fontSize.xLarge};
    line-height: 24px;
    letter-spacing: 0.1px;
    color: ${theme.colors.menuItemText};
    margin: ${theme.spacing.xSmall}px auto 0;
    max-width: 1686px;
    padding-left: ${theme.spacing.medium}px;
  }
`

export const IntegrationsTabs = styled(Tabs)<{ isdetails?: string }>`
  background: transparent;
  height: auto;
  overflow: visible;

  .MuiTabs-scroller {
    height: 34px !important;
    overflow: visible !important;

    .MuiTabs-flexContainer {
      height: 34px !important;
    }
  }

  .MuiButtonBase-root {
    border-radius: 0;
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: ${theme.typography.fontSize.large};
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: center;
    border: none;
    text-transform: none;
    height: 34px;
    min-height: 34px;
    margin-right: ${theme.spacing.large}px;
    padding-left: 0;
    padding-right: 0;
    width: fit-content;
    min-width: unset !important;
    margin-bottom: 0 !important;
    padding-bottom: 20px;
    color: ${theme.colors.calendarDay};
    font-style: normal;
    border-bottom: 2px solid transparent;
    overflow: visible;

    &:hover {
      color: ${theme.colors.menuItemText};
      font-weight: ${theme.typography.fontWeight.bold};
      border-bottom: 2px solid ${theme.colors.legacy4836462};
    }

    &.Mui-selected {
      color: ${theme.colors.menuItemText};
      font-weight: ${theme.typography.fontWeight.extraThick};
      border-bottom: 2px solid ${theme.colors.cta};
      padding-bottom: 20px;
    }

    &.Mui-disabled {
      color: ${theme.colors.btnSecondaryDisabledText};
    }
  }

  ${({ isdetails }) =>
    isdetails &&
    isdetails === 'true' &&
    `
    height: 34px;
    min-height: 34px;

    .MuiTabs-scroller {
      height: 34px;

      .MuiTabs-flexContainer {
        height: 34px;
      }
    }

    .MuiButtonBase-root {
      height: 34px;
      white-space: nowrap;
      width: fit-content;
    }
  `};
`

export const JiraTabsWrapper = styled(Box)<{ custom?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 64px;
  background: ${theme.colors.pageBackground};
`

export const JiraTabs = styled(Tabs)<{ isdetails?: string }>`
  background: transparent;
  height: auto;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.borderMedium};
  margin: 0 ${theme.spacing.medium}px;

  .MuiTabs-scroller {
    height: 64px !important;

    .MuiTabs-flexContainer {
      height: 64px !important;
      align-items: flex-end;

      .MuiButtonBase-root {
        border-radius: 0;
        font-family: ${theme.typography.fontFamily.primary};
        display: flex;
        align-items: center;
        text-align: center;
        border: none;
        text-transform: none;
        padding: 0 0 ${theme.spacing.medium}px 0;
        margin-right: ${theme.spacing.xLarge}px;
        height: 40px;
        min-height: 40px;
        white-space: nowrap;
        width: fit-content;
        color: ${theme.colors.foreground};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;

        &.Mui-selected {
          color: ${theme.colors.foreground};
          border-bottom: 4px solid ${theme.colors.cta};
        }

        &.Mui-disabled {
          color: ${theme.colors.legacySecondary802};
        }
      }
    }
  }
`

export const ConnectedProjectsWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  padding: ${theme.spacing.medium}px;
  display: flex;
  align-items: flex-start;
  overflow-x: hidden;

  .main-content-container {
    display: flex;
    align-items: center;
    width: 100%;
    flex-basis: 100%;
    height: 100%;
    overflow-x: auto;
  }

  &.no-connection {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacing.large}px;
    width: 100%;

    html[data-theme='light'] & svg path {
      fill: ${theme.colors.dropdownLabel};
    }

    .no-connection-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: ${theme.spacing.xSmall}px;

      .title {
        color: ${theme.colors.foreground};
        font-size: ${theme.typography.fontSize.xxxLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: normal;
      }

      .text {
        max-width: 400px;
        color: ${theme.colors.textSecondary};
        text-align: center;
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
      }
    }
  }
`

export const SectionsListWrapper = styled(Box)`
  width: 244px;
  min-width: 244px;
  height: 100%;
  padding-right: ${theme.spacing.medium}px;
  border-right: 1px solid ${theme.colors.strokePrimary};

  .MuiList-root {
    padding: 0;

    .MuiListItem-root {
      height: 40px;

      .MuiListItemButton-root {
        height: 40px;
        border-radius: ${theme.attributes.borderRadius.small};
        overflow: hidden;
        color: ${theme.colors.foreground};
        text-overflow: ellipsis;
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;

        &:hover {
          background: ${theme.colors.primaryLight};

          html[data-theme='light'] & {
            background: ${theme.colors.menuItemHover};
          }
        }
      }
    }
  }
`

export const MainSectionWrapper = styled(Box)`
  gap: ${theme.spacing.xLarge}px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 ${theme.spacing.medium}px;
  border-right: 1px solid ${theme.colors.strokePrimary};
  height: 100%;
  flex-basis: 50%;
  overflow-y: auto;

  .disconnect-project-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  .main-section-summary {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${theme.spacing.small}px;
    width: 100%;

    .main-section-summary-title {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.thin};
      line-height: normal;
    }

    .main-section-summary-subtitle {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;

      &.mapping-summary {
        margin: -${theme.spacing.xSmall}px 0;
      }
    }
  }

  .main-section-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${theme.spacing.xSmall}px;
    width: 100%;

    .main-section-title {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xxxLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: normal;
    }

    .main-section-subtitle {
      color: ${theme.colors.foreground};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: normal;
    }
  }

  .data-filtering-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${theme.spacing.medium}px;
    width: 100%;

    .data-filtering-header {
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: ${theme.spacing.xSmall}px;

      .data-filtering-title {
        color: ${theme.colors.foreground};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.thin};
        line-height: normal;
      }

      .data-filtering-subtitle {
        color: ${theme.colors.textSecondary};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
      }
    }

    .data-filtering-controls-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .data-filtering-actions-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: ${theme.spacing.small}px;

        .data-filtering-actions-wrapper__left {
          display: flex;
          align-items: center;
          gap: ${theme.spacing.small}px;
        }
      }
    }
  }

  .data-mapping-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.medium}px;
    justify-content: flex-start;
    width: 100%;

    .data-mapping-header {
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: ${theme.spacing.xSmall}px;

      .data-mapping-title {
        color: ${theme.colors.foreground};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.thin};
        line-height: normal;
      }

      .data-mapping-subtitle {
        color: ${theme.colors.textSecondary};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
      }
    }

    .no-mapping-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      min-height: 120px;
      gap: ${theme.spacing.xSmall}px;
      background: ${theme.colors.surfaceContainerBackground};

      .no-mapping-title {
        color: ${theme.colors.foreground};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.thin};
        line-height: normal;
      }

      .no-mapping-subtitle {
        color: ${theme.colors.textSecondary};
        text-align: center;
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
      }
    }
  }
`

export const PreviewSectionWrapper = styled(Box)`
  gap: ${theme.spacing.xLarge}px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 0 0 ${theme.spacing.medium}px;
  height: 100%;
  width: 100%;
  flex-basis: 50%;
  overflow-y: auto;
  overflow-x: hidden;

  .empty-preview {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: ${theme.spacing.large}px;

    .empty-preview-image {
      min-width: 128px;
      min-height: 128px;

      html[data-theme='light'] & path {
        fill: ${theme.colors.dropdownLabel};
      }
    }

    .empty-preview-header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      gap: ${theme.spacing.xSmall}px;

      .empty-preview-title {
        color: ${theme.colors.foreground};
        font-size: ${theme.typography.fontSize.xxxLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: normal;
      }

      .empty-preview-subtitle {
        color: ${theme.colors.textSecondary};
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
      }
    }
  }
`

export const IntegrationsListWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column wrap;
  max-width: 920px;
  width: 100%;
`

export const ErrorSpan = styled.span`
  font-size: ${theme.typography.fontSize.medium};
  line-height: 16px;
  font-weight: 700;
  color: ${theme.colors.purpleDark};
`

export const ActionSpan = styled.span`
  display: inline;
  font-size: ${theme.typography.fontSize.medium};
  line-height: 18px;
  font-weight: 300;
  color: ${theme.colors.purpleDark};
  text-decoration: underline;
  cursor: pointer;
`

export const AppContainer = styled(Box)`
  display: flex;
  min-height: 100vh;
  width: 100%;
  background-color: ${theme.colors.surfaceContainerBackground};
  color: ${theme.colors.foreground};
`

export const MainContent = styled(Box)`
  margin: 0;
  width: 100%;
  background-color: ${theme.colors.pageBackground};
`

export const ScrollableContent = styled(Box)`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(100vh - 264px);
  padding-top: ${theme.spacing.medium}px;

  ::-webkit-scrollbar {
    width: 12px !important;
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background: ${theme.colors.pageBackground};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.borderMedium};
  }
`

export const Header = styled(Box)`
  width: 100%;
  height: 130px;
  background: ${theme.colors.surfaceContainerBackground};

  .title {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxxLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 48px;
    padding-top: ${theme.spacing.small}px;
    padding-left: ${theme.spacing.medium}px;
  }
`

export const ContentWrapper = styled(Box)``

export const StyledTabs = styled(Tabs)`
  margin-bottom: 0;
  height: 34px;
  min-height: 34px;
  border-bottom: 1px solid ${theme.colors.borderMedium};
  padding-left: ${theme.spacing.medium}px;

  .MuiTabs-scroller {
    .MuiTabs-flexContainer {
      gap: ${theme.spacing.large}px;

      .MuiButtonBase-root {
        padding-left: 0;
        padding-right: 0;
        width: fit-content;
        height: 34px;
        min-height: 34px;
        color: ${theme.colors.menuItemText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.extraThick};
        line-height: 22px;
        justify-content: flex-end;
        border-bottom: 3px solid transparent;

        &:not(.Mui-selected) {
          color: ${theme.colors.devicesSecondaryText};
          font-weight: ${theme.typography.fontWeight.bold};
        }

        &:hover {
          color: ${theme.colors.menuItemText};
          border-bottom: 3px solid ${theme.colors.btnTertiaryBg};
        }
      }
    }
  }

  & .MuiTabs-indicator {
    background-color: ${theme.colors.cta} !important;
    height: 2px;
  }
`

export const ControlsSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: ${theme.spacing.small}px;
  padding: ${theme.spacing.medium}px ${theme.spacing.medium}px 0;

  .sort-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .number-of-items {
      color: ${theme.colors.dropdownLabel};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 22px;

      span {
        color: ${theme.colors.menuItemText};
      }
    }
  }
`

export const FiltersContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing.md}px;
  align-items: flex-end;
  background-color: ${theme.colors.pageBackground};
  border-radius: ${theme.attributes.borderRadius.mediumSmall};

  .MuiFormControl-root {
    background: transparent;

    fieldset {
      border: 0;
      outline: 0;
    }
  }

  html[data-theme='light'] & {
    .MuiAutocomplete-root,
    .dropdown-container > .MuiFormControl-root {
      background: ${theme.colors.surfaceContainerBackground};
    }

    /* Unselected value reads as a placeholder; a chosen value keeps the accent. */
    .dropdown-container [isselected='false'] .MuiSelect-select {
      color: ${theme.colors.textCaption};
    }
  }
`

export const StyledTab = styled(Tab)<{ active?: boolean }>`
  color: ${(props) => (props.active ? `${theme.colors.foreground}` : '#666680')};
  text-transform: none;
  min-width: 120px;
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: ${theme.typography.fontSize.large};

  &.Mui-selected {
    color: ${theme.colors.foreground};
  }
`

export const IntegrationsGridWrapper = styled(Box)`
  padding: 0 ${theme.spacing.medium}px 0;
  margin-bottom: ${theme.spacing.xLarge}px;

  .title-wrapper {
    padding-bottom: ${theme.spacing.small}px;
    border-bottom: 1px solid ${theme.colors.borderMedium};

    .integrations-category-title {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
    }
  }
`

export const ResetButton = styled(Button)`
  display: flex;
  padding: 14px ${theme.spacing.small}px;
  align-items: center;
  gap: ${theme.spacing.small}px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.btnSecondaryBorder};
  color: ${theme.colors.devicesSecondaryText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  text-transform: none;
  height: 48px;

  &:hover {
    border-color: #6c5b67;
    color: ${theme.colors.menuItemText};
    background: ${theme.colors.borderMedium};
  }
`

export const GridContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${CARD_MIN_WIDTH}px, 1fr));
  gap: ${theme.spacing.medium}px;
  padding-top: 16px;

  @media screen and (min-width: 1200px) and (max-width: 1920px) {
    grid-template-columns: repeat(auto-fill, minmax(${CARD_MIN_WIDTH_SMALL}px, 1fr));
    gap: ${theme.spacing.small}px;
  }
`
